import request from "api/axiosClient";
import { COMMON_SERVICES } from "constants/apiEndPoint";
/*
This place contains all the common API requests that are used in the application.
*/

export const getServices = async (data) => {
  const result = await request({
    url: COMMON_SERVICES,
    method: "POST",
    data: data
  });
  return result?.data;
};

export const getServicePackages = async (serviceIds) => {
  const result = await request({
    url: "common/service-packages",
    method: "POST",
    data: { serviceIds }
  });
  return result?.data;
};
export const getPaymentChannels = async () => {
  const result = await request({
    url: "common/payment-channels",
    method: "POST",
  });
  return result?.data;
};
export const getTransactionTypes = async () => {
  const result = await request({
    url: "common/transaction-types",
    method: "POST",
  });
  return result?.data;
};
export const getPlatforms = async () => {
  const result = await request({
    url: "common/platforms",
    method: "POST",
  });
  return result?.data;
};
export const getCampaigns = async () => {
  const result = await request({
    url: "common/campaigns",
    method: "POST",
  });
  return result?.data;
};

export const getMetrics = async (type) => {
  const result = await request({
    url: "common/metrics",
    method: "POST",
    data: { type: type }
  });
  return result?.data;
};
export const getDimensions = async (type) => {
  const result = await request({
    url: "common/dimensions",
    method: "POST",
    data: { type: type }
  });
  return result?.data;
};
export const getChannels = async () => {
  const result = await request({
    url: "common/channels",
    method: "POST",
  });
  return result?.data;
};
export const getOrderStatuses = async () => {
  const result = await request({
    url: "common/order-statuses",
    method: "POST",
  });
  return result?.data;
}
export const getStaffs = async () => {
  const result = await request({
    url: "common/staffs",
    method: "POST",
  });
  return result?.data;
}
export const getCallNumbs = async () => {
  const result = await request({
    url: "common/call-numbs",
    method: "POST",
  });
  return result?.data;
}
export const getOrderTypes = async () => {
  const result = await request({
    url: "common/order-types",
    method: "POST",
  });
  return result?.data;
}

export const getRates = async () => {
  const result = await request({
    url: "common/rates",
    method: "POST",
  });
  return result?.data;
}

export const getCauhois = async () => {
  const result = await request({
    url: "common/cauhois",
    method: "POST",
  });
  return result?.data;
}

export const getAppVersions = async () => {
  const result = await request({
    url: "common/app-versions",
    method: "POST",
  });
  return result?.data;
}

export const getOrderCallNotes = async () => {
  const result = await request({
    url: "common/orderCallNotes",
    method: "POST",
  });
  return result?.data;
}

export const getAudiences = async () => {
  const result = await request({
    url: "common/audiences",
    method: "POST",
  });
  return result?.data;
}

export const getPremiumOrderNotes = async () => {
  const result = await request({
    url: "common/premiumOrderNotes",
    method: "POST",
  });
  return result?.data;
}

export const getApiNames = async () => {
  const result = await request({
    url: "common/apiNames",
    method: "POST",
  });
  return result?.data;
}

export const getRelationNames = async () => {
  const result = await request({
    url: "common/relationNames",
    method: "POST",
  });
  return result?.data;
}

export const getCallNumbPerDay = async () => {
  const result = await request({
    url: "common/call-numb-per-days",
    method: "POST",
  });
  return result?.data;
}

export const getCustomerOverview = async (values) => {
  const result = await request({
    url: "common/customer-overview",
    method: "POST",
    data: values
  });
  return result?.data;
}

export const getAttributes = async () => {
  const result = await request({
    url: "common/attributes",
    method: "POST",
  });
  return result?.data;
}
export const getColumnToExportAudience = async () => {
  const result = await request({
    url: "common/getColumnToExportAudience",
    method: "POST",
  });
  return result?.data;
}

export const getGoodDaySelectionWorkList = async (values) => {
  const result = await request({
    url: "common/getGoodDaySelectionWorkList",
    method: "POST",
    data: values
  });
  return result?.data;
}

export const getAttributeValues = async (attributeName) => {
  const result = await request({
    url: "common/attributeValues",
    method: "POST",
    data: { attributeName: attributeName }
  });
  return result?.data;
}

export const getPartners = async (attributeName) => {
  const result = await request({
    url: "common/partners",
    method: "POST",
    data: { attributeName: attributeName }
  });
  return result?.data;
}

export const getMiniapps = async (attributeName) => {
  const result = await request({
    url: "common/miniapps",
    method: "POST",
    data: { attributeName: attributeName }
  });
  return result?.data;
}

export const getOnlineStoreOrderStatus = async () => {
  const result = await request({
    url: "common/online-store-order-status",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreUrl = async () => {
  const result = await request({
    url: "common/online-store-url",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStorePeriod = async () => {
  const result = await request({
    url: "common/online-store-period",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreCampaign = async () => {
  const result = await request({
    url: "common/online-store-campaign",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreField = async () => {
  const result = await request({
    url: "common/online-store-field",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreProduct = async () => {
  const result = await request({
    url: "common/online-store-product",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreClassify = async () => {
  const result = await request({
    url: "common/online-store-classify",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreSupplier = async () => {
  const result = await request({
    url: "common/online-store-supplier",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStorePaymentChannel = async () => {
  const result = await request({
    url: "common/online-store-payment-channel",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreSaleChannel = async () => {
  const result = await request({
    url: "common/online-store-sale-channel",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreCancelReason = async () => {
  const result = await request({
    url: "common/online-store-cancel-reason",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStorePaymentStatus = async () => {
  const result = await request({
    url: "common/online-store-payment-status",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreReferralCode = async () => {
  const result = await request({
    url: "common/online-store-referral-code",
    method: "POST",
  });
  return result?.data;
}

/*
Nhóm API dropdown của các màn hình đọc DB online_store (gian hàng).
Đặt tên số nhiều để không đụng các hàm số ít phía trên (thuộc màn hình Cát Việt Shop,
hiện chưa có route và chưa có API tương ứng ở backend).
*/
export const getOnlineStoreSuppliers = async () => {
  const result = await request({
    url: "common/online-store-supplier",
    method: "POST",
  });
  return result?.data;
}

export const getOnlineStoreCategories = async (supplierIds = []) => {
  const result = await request({
    url: "common/online-store-category",
    method: "POST",
    data: { supplierIds }
  });
  return result?.data;
}

export const getOnlineStoreProducts = async (supplierIds = [], categoryIds = []) => {
  const result = await request({
    url: "common/online-store-product",
    method: "POST",
    data: { supplierIds, categoryIds }
  });
  return result?.data;
}

// Trạng thái đơn của DB online_store (khác getOnlineStoreOrderStatus - trạng thái đơn mini-app).
export const getOnlineStoreOrderStatusCodes = async () => {
  const result = await request({
    url: "common/online-store-order-status-code",
    method: "POST",
  });
  return result?.data;
}

export const getStatusCodes = async () => {
  const result = await request({
    url: "common/statusCodes",
    method: "POST",
  });
  return result?.data;
}

export const getHours = async () => {
  const result = await request({
    url: "common/hours",
    method: "POST",
  });
  return result?.data;
}

// Hai bo loc moi cua bao cao Truy cap API. Danh sach lay tu du lieu that tren ClickHouse
// nen luon khop voi so lieu bao cao ve ra.
export const getApiHosts = async () => {
  const result = await request({
    url: "common/apiHosts",
    method: "POST",
  });
  return result?.data;
}

export const getApiMethods = async () => {
  const result = await request({
    url: "common/apiMethods",
    method: "POST",
  });
  return result?.data;
}

export const getTemplateIds = async () => {
  const result = await request({
    url: "common/template-ids",
    method: "POST",
  });
  return result?.data;
}

export const responseMessages = async () => {
  const result = await request({
    url: "common/response-messages",
    method: "POST",
  });
  return result?.data;
}

export const getPackageDurations = async () => {
  const result = await request({
    url: "common/package-durations",
    method: "POST",
  });
  return result?.data;
}